<script lang="ts">
    import {getCurrentLanguage, getInjector} from 'src/core';
    import {fade} from 'svelte/transition';
    import {LandingPageStatsDataService} from '../kp-landing-page-stats/landing-page-stats.data-service';

    const landingPageStatsDataService = getInjector().getByClass(LandingPageStatsDataService);
    const currentLanguage = getCurrentLanguage();

    const data = landingPageStatsDataService.get().then((search) => search.result);

    const documentsCountPromise = data.then((result) => result.documentsCount);
</script>

<span class="documents-count">
    {#await documentsCountPromise}
        <div class="pulse-loader" out:fade|global={{duration:200}}></div>
    {:then value}
        <div class="documents-count-value" in:fade|global={{duration:200}}>
            {value.count.toLocaleString(currentLanguage)}
        </div>
    {/await}
</span>